// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BannerRelated_main__BWXg1 {
    width: 100%;
}

.BannerRelated_header__PnDde {
    height: 35px;
    margin-bottom: 25px;
}

.BannerRelated_title__OM\\+KU {
    font-size: 30px;
}

.BannerRelated_container__lXrze {
    width: 100%;
    min-height: calc(100% - 60px);
    padding: 10px;
    border-radius: 6px;
    background-color: #ffffff;
}

.BannerRelated_add_box__FrfSR {
    width: 100%;
    height: 50px;
}

.BannerRelated_table_box__SsGG8 {
    width: 100%;
}

.BannerRelated_preview_box__w6p6s {
    width: 100%;
    height: 500px;
    padding-top: 30px;
    border-top: 1px solid #ccc;
    margin-top: 30px;
}

.BannerRelated_preview_title__iVvfT {
    font-size: 20px;
    padding: 5px 0;
}

.BannerRelated_preview_box_banner__co6Bv {
    width: 70%;
    height: 133px;
    border: 1px solid #ccc;
    border-radius: 12px;
    margin: 0 auto;
}

.BannerRelated_publish_box__1yjyf {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/BannerRelated/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,aAAa;AACjB","sourcesContent":[".main {\n    width: 100%;\n}\n\n.header {\n    height: 35px;\n    margin-bottom: 25px;\n}\n\n.title {\n    font-size: 30px;\n}\n\n.container {\n    width: 100%;\n    min-height: calc(100% - 60px);\n    padding: 10px;\n    border-radius: 6px;\n    background-color: #ffffff;\n}\n\n.add_box {\n    width: 100%;\n    height: 50px;\n}\n\n.table_box {\n    width: 100%;\n}\n\n.preview_box {\n    width: 100%;\n    height: 500px;\n    padding-top: 30px;\n    border-top: 1px solid #ccc;\n    margin-top: 30px;\n}\n\n.preview_title {\n    font-size: 20px;\n    padding: 5px 0;\n}\n\n.preview_box_banner {\n    width: 70%;\n    height: 133px;\n    border: 1px solid #ccc;\n    border-radius: 12px;\n    margin: 0 auto;\n}\n\n.publish_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    padding: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `BannerRelated_main__BWXg1`,
	"header": `BannerRelated_header__PnDde`,
	"title": `BannerRelated_title__OM+KU`,
	"container": `BannerRelated_container__lXrze`,
	"add_box": `BannerRelated_add_box__FrfSR`,
	"table_box": `BannerRelated_table_box__SsGG8`,
	"preview_box": `BannerRelated_preview_box__w6p6s`,
	"preview_title": `BannerRelated_preview_title__iVvfT`,
	"preview_box_banner": `BannerRelated_preview_box_banner__co6Bv`,
	"publish_box": `BannerRelated_publish_box__1yjyf`
};
export default ___CSS_LOADER_EXPORT___;
